import { FC, useState, useEffect, useRef } from "react";
import { useApp } from "../../context/useApp";
import { _ } from "../../utils/helpers";
import { Icon } from "../../parts/Icon";
import { rumba, SCREEN_BREAKPOINT_1 } from "../../utils/symbols";
import { CheckBox } from "../../parts/inputs/CheckBox";

export const TermsAndConditions: FC = ({}) => {

    const {state: { booking, screen, shifts }} = useApp()
    const shift = shifts.find(shift => shift.id === booking.shiftId)
    const mail = rumba.venueId === 1 ? 'reservas@cardamomo.com' : 'reservas@tablaoflamenco1911.com'

    return screen.width > SCREEN_BREAKPOINT_1 ? (
                <fieldset id="terms-and-condition" className="mb-11">
                    <p id="conditions"  
                        className="text s14-500 softer" 
                        aria-label={_('5tc_bysub__', mail)}
                        dangerouslySetInnerHTML={{__html: `<span aria-hidden="true" >${_('5tc_bysub__')}</span><a href="mailto:${mail}">${mail}</a>`}}
                    >
                    </p>
                </fieldset>
    )
    : null
}